export default import.meta.ROLLDOWN_FILE_URL_zxaNXXXI6j0UkewQ7cz7Iw